export const SORT_ITEMS = [
  {label: 'Name', key: 'firstName'},
  {label: 'Date of Creation', key: 'createdAt'},
]

export const DEFAULT_SORT_KEY = 'firstName'

export const URL_BASE_RBAC = `${process.env.REACT_APP_URL_BASE_RBAC}`

export const VC_TEAM_ID = `${process.env.REACT_APP_VC_TEAM_ID}`
